export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-950"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20magazine%20background%20with%20abstract%20geometric%20shapes%2C%20deep%20charcoal%20black%20tones%2C%20warm%20crimson%20red%20and%20amber%20gold%20accent%20lighting%2C%20cinematic%20atmosphere%2C%20luxurious%20dark%20texture%2C%20mysterious%20and%20intriguing%20mood%2C%20high-end%20editorial%20photography%20style%20with%20dramatic%20contrast%20and%20soft%20gradients&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="黑料吃瓜在线背景"
        className="absolute inset-0 w-full h-full object-cover object-top opacity-50"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium tracking-wider uppercase mb-5">
              每日更新 · 全网最热
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              黑料吃瓜在线
              <br />
              <span className="text-primary-400">全网八卦热榜第一站</span>
            </h1>

            <p className="text-background-200/80 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              一站式浏览娱乐圈、网红圈最新黑料与吃瓜内容。从热搜爆料到独家深扒，覆盖明星八卦、网红翻车、综艺名场面等多元话题。每日精选全网热议事件，以最快速度同步最热内容，让你不错过每一个精彩瞬间。
            </p>

            <p className="text-background-300/70 text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              当前平台覆盖 30+ 主流信息源，日更新 200+ 条热点动态，累计收录 50,000+ 条爆料记录。内容均来自公开渠道聚合，仅供吃瓜娱乐参考。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl font-bold">200+</div>
                <div className="text-background-300/70 text-xs mt-1">日均更新</div>
              </div>
              <div className="w-px h-10 bg-background-500/30"></div>
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl font-bold">30+</div>
                <div className="text-background-300/70 text-xs mt-1">信息源覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-500/30"></div>
              <div className="text-center">
                <div className="text-accent-400 font-heading text-2xl md:text-3xl font-bold">24h</div>
                <div className="text-background-300/70 text-xs mt-1">实时同步</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer animate-pulse-glow"
              >
                <i className="ri-fire-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-300/30 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-900/50">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20magazine%20cover%20style%20composition%20with%20abstract%20shapes%2C%20glowing%20warm%20crimson%20and%20amber%20light%20streaks%2C%20mysterious%20silhouettes%2C%20dramatic%20lighting%20on%20dark%20background%2C%20luxurious%20texture%2C%20cinematic%20mood%2C%20high-end%20editorial%20design%20with%20elegant%20geometric%20elements&width=900&height=675&seq=hero-visual-2026&orientation=landscape"
                alt="黑料吃瓜在线 - 全网八卦热榜"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full">🔥 实时热搜</span>
                <span className="px-3 py-1 bg-background-950/70 text-background-200 text-xs rounded-full">今日 TOP 10</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}